export enum BreakpointMedia {
  // min-width
  MIN_XL = '(min-width: 1920px)',
  MIN_LG = '(min-width: 1024px)',
  MIN_MD = '(min-width: 768px)',
  MIN_SM = '(min-width: 440px)',
  MIN_XS = '(min-width: 390px)',
  MIN_LTO = '(min-width: 1332px)',

  // max-width
  MAX_XL = '(max-width: 1920px)',
  MAX_LG = '(max-width: 1024px)',
  MAX_MD = '(max-width: 768px)',
  MAX_SM = '(max-width: 440px)',
  MAX_XS = '(max-width: 390px)',
}

export enum BannerVariant {
  REACTIVATION = 'reactivation',
  ADMIN_STATUS = 'adminStatus',
}

export enum BreakpointValue {
  XL = 1920,
  LG = 1024,
  MD = 768,
  SM = 430,
  XS = 390,
  XXS = 389,
}

export enum Route {
  // Logged In Hub
  HUB = '/upcoming-menus',
  ORDER_CONFIRMATION = '/thankyou',
  ORDER_HISTORY = '/order-history',
  TRACKING = '/tracking',
  // Logged Out Hub
  SHOP = '/shop',
  // LTO
  ROBIN_ARZON = '/lto/robin-arzon',
  // Account Management
  ACCOUNT_SETTINGS = '/account-settings',
  DELIVERY_ADDRESS = '/address',
  NOTIFICATION_PREFERENCES = '/notification-preferences',
  PAYMENT_METHOD = '/payment-method',
  PROFILE = '/profile',
  // Misc Logged In Pages
  ADMIN = '/admin',
  MANAGE_SUBSCRIPTION = '/manage-subscription',
  MY_FAVORITES = '/myfavorites',
  PDP = '/recipe/:slug',
  REDEEM_CODE = '/redeem-a-gift',
  SHARE_A_BOX = '/giveaways',
  REFER = '/refer',
  ALL_RECIPES = '/plant-based-recipes',
  RECYCLE = '/recycle',
  FROZEN = '/frozen-meals',
  // Global Pages
  WHY_PLANTS = '/why-plants',
  CONTACT_US = '/contacts/new',
  FAQS = 'https://purplecarrot.zendesk.com/hc/en-us',
  GIFTS = '/gifts',
  AFFILIATE = 'https://app.impact.com/campaign-mediapartner-signup/Purple-Carrot.brand?execution=e1s1',
  CAREERS = 'https://apply.workable.com/thepurplecarrot/?lng=en',
  LEARN_MORE = '/learn',
  // Signup
  SIGNUP_PLAN = '/users/sign_up',
  SIGNUP_CHECKOUT = '/sign_up',
  SIGNUP_CHECKOUT_REDEEM = '/redeem_signup',
  // Terms and Conditions
  TERMS = '/terms',
  PRIVACY = '/privacy',
  CALIFORNIA_PRIVACY = '/california_privacy',
  DO_NOT_SELL = '/do_not_sell',
  ACCESSIBILITY = '/accessibility',
  SITE_MAP = '/sitemap',
  // Download App
  APPLE_DOWNLOAD = 'https://apps.apple.com/us/app/id6444125328',
  ANDROID_DOWNLOAD = 'https://play.google.com/store/apps/details?id=com.purplecarrot.mobile',
  // Social Media
  FACEBOOK = 'https://www.facebook.com/purplecarrotxo',
  PINTEREST = 'https://pinterest.com/thepurplecarrot',
  TWITTER = 'https://www.twitter.com/purplecarrotxo',
  INSTAGRAM = 'http://instagram.com/purplecarrotxo',
}

export enum ApiRoute {
  CURRENT_SUBSCRIPTION = '/api/v2/subscriptions/me',
  PREVIEW = '/api/v2/carts/preview',
  MENUS = '/api/v2/menus',
  CARTS = '/api/v2/carts',
  CURRENT_USER = '/api/v2/users/me',
  LTO = '/api/v2/lto',
  PRODUCTS = '/api/v1/products',
  PRODUCT_REVIEWS = '/api/v1/products',
  APPLY_REBUTTAL_PROMO = '/api/v1/code_redemption/apply_rebuttal_promo',
  PRODUCTS_V2 = '/api/v2/products',
  CREATE_ACCOUNT = '/users',
  CREATE_ADDRESS = '/api/v1/shipping_addresses',
  GET_ADDRESSES = '/api/v1/shipping_addresses',
  LOGIN_ACCOUNT = '/users/sign_in?remote=true',
  PAYMENT_TOKEN = '/braintree_client_code',
  PAYMENT_METHOD = '/api/v1/users/me/payment_method',
  GOOGLE_SSO = '/users/auth/google_oauth2',
  APPLE_SSO = '/users/auth/apple',
  FACEBOOK_SSO = '/users/auth/facebook',
  ACTIVATE = '/api/v1/subscription/activate',
  USERS = '/api/v1/users',
  COUPONS = '/api/v2/coupons',
  DO_NOT_SELL = '/do_not_sell',
  FAVORITE_PRODUCT = '/api/v2/favorites',
}

export enum PaymentUpdateFunnel {
  STANDARD_SIGNUP = 'Standard SignUp',
  EXPRESS_SIGNUP = 'Express SignUp',
  USER_PROFILE = 'User Profile',
}

export enum PaymentService {
  CREDIT_CARD = 'BraintreeCreditCard',
  PAYPAL = 'Braintree',
  GOOGLE_PAY = 'BraintreeGooglePayCard',
  APPLE_PAY = 'BraintreeApplePayCard',
  VENMO = 'BraintreeVenmo',
}

export enum PaymentType {
  CREDIT_CARD = 'CreditCard',
  PAYPAL = 'PayPalAccount',
  GOOGLE_PAY = 'AndroidPayCard',
  APPLE_PAY = 'ApplePayCard',
}

export const emailRegexp = /[\w+-.]+@[a-z\d-]+(\.[a-z\d-]+)*\.[a-z]+/i;

export const MAX_ADDRESS2_LENGTH = 30;
